import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import PropTypes from 'prop-types'
import SimpleInput from 'components/forms/SimpleInput'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ExportAction from 'export/actions/ExportAction'
import { minBy, maxBy, template } from 'lodash'
import { getTimestamp } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { formatedFileName } from 'utils/FileUtils'
import { QUALITY_CAMPAIGN_REQUEST_CONSTANTS } from 'campaign/constants/CampaignConstants'

const PopupExportFullEDILABODAI = ({ isOpen, onClose }) => {
    const {
        campaign,
        campaignPlannings,
        edilaboFiles,
    } = useSelector(store => ({
        campaign: store.CampaignReducer.campaign,
        campaignPlannings: store.CampaignReducer.campaignPlannings,
        edilaboFiles: store.CampaignReducer.edilaboFiles,
    }), shallowEqual)

    const [fileName, setFileName] = useState(formatedFileName(`${campaign.name}-DAI`))

    const dispatch = useDispatch()

    useEffect(() => {
        setFileName(formatedFileName(`${campaign.name}-DAI`))
    }, [campaign])

    const startDate = campaignPlannings.length ? minBy(campaignPlannings, 'startDate').startDate : getTimestamp(campaign.beginningApplication)
    const endDate = (campaignPlannings.length ? maxBy(campaignPlannings, 'endDate').endDate : getTimestamp(campaign.endingApplication)) ?? startDate

    const onExport = () => {
        const lastFile = maxBy(edilaboFiles, 'updateDate')
        const exportPath = lastFile ? lastFile.href.split('EXPORT/EDILABO/')[1].replace(lastFile.label, '') : ''
        const samplerCode = hasValue(campaign.samplerCode) ? parseInt(campaign.samplerCode) : undefined
        const recipientCode = hasValue(campaign.recipientCode) ? parseInt(campaign.recipientCode) : undefined
        dispatch(ExportAction.exportEDILABOPlanning({
            campaignId: campaign.id,
            exportPath,
            requestName: fileName,
            startDate,
            endDate,
            codifications: [], // [{ stationId: Int, codification: Int }]
            sender: hasValue(campaign.contributorCode) ? parseInt(campaign.contributorCode) : undefined,
            receiver: (() => {
                switch (campaign.requestType) {
                    case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.SAMPLE_REQUEST:
                        return samplerCode
                    case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.ANALYSIS_REQUEST:
                        return recipientCode
                    case QUALITY_CAMPAIGN_REQUEST_CONSTANTS.MIXED_REQUEST:
                        return recipientCode || samplerCode
                    default:
                        return undefined
                }
            })(),
        })).then(() => onClose())
    }

    return (
        <Dialog open={isOpen} onClose={onClose} >
            <DialogTitle>{i18n.EDILABODAI}</DialogTitle>
            <DialogContent>
                <SimpleInput title={i18n.fileName} value={fileName} onChange={(v) => setFileName(formatedFileName(v))} maxLength={34} helperText={template(i18n.maxXCharacters)({ nbChar: 34 })} />
            </DialogContent>
            <DialogActions>
                <Button variant={'outlined'} onClick={onClose}>{i18n.cancel}</Button>
                <Button variant={'contained'} onClick={onExport} disabled={!fileName}>{i18n.validate}</Button>
            </DialogActions>
        </Dialog>
    )
}

PopupExportFullEDILABODAI.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
}

export default PopupExportFullEDILABODAI